import { buildWindowScript, chartAdvice } from '../../../platform/tradingview';
import config from '../config';

// PredictionDetail supplies this model's window. Legacy session-based records
// retain their original open/close chart and previous-session comparison.
export const chartWindow = batch => batch.price_basis === 'minute_window' ? ({
  start: batch.window_start || batch.prediction_time,
  end: batch.target_close,
}) : ({
  start: { date: batch.end_date, hour: 9, minute: 30 },
  end: batch.target_close,
  priorClose: true,
});

// What SymbolChart needs for each ticker on a prediction's page.
export function chartFor(batch, prices = []) {
  const span = chartWindow(batch);
  return {
    advice: chartAdvice(span),
    build: symbol => () => {
      const p = prices.find(x => x.symbol === symbol);
      return buildWindowScript({
        symbol, window: span,
        recorded: { start: p?.start_close, end: p?.end_close },
        title: `${config.title} · ${batch.horizon}`,
        url: globalThis.location?.href || '',
      });
    },
  };
}
